module.exports = __webpack_public_path__ + "static/img/record_local1.633f1b0f.png";